import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinpimprichichwad() {



  const cardData = {




keyword: "Cab Service in Pimpri Chinchwad",

headingDescription: "Garud Cab Service provides comfortable and reliable Cab Service in Pimpri Chinchwad for families, corporate travelers, tourists, senior citizens, students, and groups looking for convenient local and outstation transportation. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for local travel, airport transfers, railway station pickups, corporate transportation, sightseeing, one-way journeys, round trips, and customized outstation trips. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations across Pimpri Chinchwad, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes travel from PCMC smooth and convenient. Travelers can also arrange private cabs for nearby hill stations, pilgrimage destinations, coastal getaways, business locations, and long-distance routes according to their preferred schedule.",

topPlaces: [
  {
    title: "Bhimashankar",
    description: "Bhimashankar is an important pilgrimage and nature destination surrounded by the Sahyadri ranges, forests, and scenic landscapes. The Jyotirlinga Temple attracts devotees from Pimpri Chinchwad throughout the year. Garud Cab Service provides comfortable private cabs for families and groups planning one-way, round-trip, or customized pilgrimage journeys."
  },
  {
    title: "Malshej Ghat",
    description: "Malshej Ghat is a scenic Western Ghats destination known for mountains, waterfalls, valleys, and lush monsoon greenery. It is suitable for weekend road trips and nature outings from Pimpri Chinchwad. Customers can book Sedan, SUV, Ertiga, Innova, or Innova Crysta with a professional chauffeur and flexible sightseeing arrangements."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for scenic viewpoints, lakes, waterfalls, valleys, and strawberry farms. Families and groups from Pimpri Chinchwad can enjoy a comfortable private road journey without changing vehicles. Garud Cab Service offers spacious vehicles with flexible one-way, round-trip, and multi-day travel options."
  },
  {
    title: "Shirdi",
    description: "Shirdi is a major pilgrimage destination visited by devotees throughout the year for Sai Baba darshan. Families, senior citizens, and groups from Pimpri Chinchwad can travel conveniently in a chauffeur-driven cab with sufficient luggage space. Customers can customize their pilgrimage journey with temple visits, overnight stays, and return travel arrangements."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill station close to Pimpri Chinchwad and is known for waterfalls, lakes, green valleys, caves, and historic forts. It is ideal for short family outings, weekend trips, and group travel. Garud Cab Service provides private cabs with flexible pickup timings and customized sightseeing routes around Lonavala."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal getaway known for beaches, forts, resorts, and peaceful seaside surroundings. Travelers from Pimpri Chinchwad can plan a family holiday or weekend coastal trip with a comfortable private cab. Customers can choose a suitable vehicle and customize their route with sightseeing stops and flexible return options."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious, cultural, and commercial destination known for temples, heritage sites, vineyards, and scenic surroundings. Customers from Pimpri Chinchwad can book private cabs for pilgrimage, business travel, family visits, or sightseeing. Garud Cab Service provides comfortable vehicles with professional chauffeurs and flexible one-way or round-trip options."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a scenic hill station surrounded by mountains, valleys, viewpoints, and green landscapes. It is a suitable destination for families and couples planning a peaceful weekend trip from Pimpri Chinchwad. Customers can combine Panchgani with Mahabaleshwar and other nearby attractions through a customized private cab itinerary."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a peaceful destination in the Sahyadri ranges known for lakes, waterfalls, forests, and mountain scenery. It is well suited for families, nature lovers, and groups planning a longer weekend journey. Garud Cab Service provides comfortable chauffeur-driven cabs with flexible sightseeing and multi-day travel arrangements."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is an important cultural and religious city known for Mahalaxmi Temple, historic sites, traditional cuisine, and regional attractions. Travelers from Pimpri Chinchwad can book a private cab for pilgrimage, family visits, business travel, or sightseeing. Customers can select spacious vehicles for comfortable long-distance travel with luggage."
  }
],




"services": [
{
"name": "Cab Service in Pimpri Chinchwad",
"description": "Book Cab Service in Pimpri Chinchwad for comfortable and convenient local and outstation transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for families, business travelers, tourists, airport transfers, and daily travel requirements."
},
{
"name": "Cab Services in PCMC",
"description": "Choose Cab Services in PCMC for reliable transportation across Pimpri-Chinchwad areas with convenient pickup arrangements. Sedan, SUV, Innova, and premium vehicles can be arranged for local trips, airport transfers, business travel, and outstation journeys."
},
{
"name": "Cab Services in Wakad",
"description": "Book Cab Services in Wakad for comfortable local and long-distance transportation with professional driver assistance. The service is suitable for residents, corporate passengers, families, airport travelers, and customers planning outstation trips from Wakad."
},
{
"name": "Cab Service in Aundh",
"description": "Choose Cab Service in Aundh for convenient chauffeur-driven transportation for local travel, airport transfers, business trips, and outstation journeys. Comfortable AC cars can be arranged according to passenger count, luggage, and travel requirements."
},
{
"name": "Cab Service in Baner",
"description": "Book Cab Service in Baner for reliable private transportation with flexible pickup and drop arrangements. Sedan, SUV, Innova, and premium vehicles are suitable for local travel, corporate requirements, airport transfers, family trips, and outstation journeys."
},
{
"name": "Cab Service in Bhosari",
"description": "Choose Cab Service in Bhosari for convenient local and outstation transportation with experienced chauffeurs and comfortable vehicles. The service is suitable for industrial travel, business passengers, families, airport transfers, and long-distance journeys."
},
{
"name": "Outstation Cab Booking Pimpri Chinchwad",
"description": "Make Outstation Cab Booking Pimpri Chinchwad for scheduled private transportation to destinations across Maharashtra and neighboring states. Customers can select suitable sedan, SUV, Innova, and larger vehicles according to passenger and luggage requirements."
},
{
"name": "Cab Service in Hinjewadi Pune",
"description": "Book Cab Service in Hinjewadi Pune for convenient transportation for IT professionals, corporate passengers, families, and travelers. Chauffeur-driven cars can be arranged for local travel, airport transfers, business visits, and outstation journeys."
},
{
"name": "Cab Service in Hinjewadi Phase 1",
"description": "Choose Cab Service in Hinjewadi Phase 1 for comfortable transportation with convenient pickup from residential and commercial locations. The service is suitable for corporate travel, airport transfers, local journeys, family trips, and outstation requirements."
},
{
"name": "Cab Service in Hinjewadi Phase 2",
"description": "Book Cab Service in Hinjewadi Phase 2 for reliable chauffeur-driven transportation for employees, business travelers, families, and individuals. Comfortable AC vehicles can be arranged for local travel, airport drops, meetings, and long-distance journeys."
},
{
"name": "Cab Service in Hinjewadi Phase 3",
"description": "Choose Cab Service in Hinjewadi Phase 3 for convenient private transportation with flexible pickup and destination drop. Sedan, SUV, and premium vehicles can be arranged for corporate travel, airport transfers, family journeys, and outstation trips."
},
{
"name": "Cab Service in Nigdi Pradhikaran",
"description": "Book Cab Service in Nigdi Pradhikaran for comfortable local and outstation travel with professional chauffeurs. The service is suitable for families, corporate passengers, airport travelers, tourists, and individuals requiring convenient private transportation."
},
{
"name": "Cab Service in Pune for Outstation",
"description": "Choose Cab Service in Pune for Outstation journeys to nearby cities, tourist destinations, business locations, and pilgrimage places. Comfortable chauffeur-driven cars can be arranged for one-way, round-trip, family, corporate, and long-distance travel."
},
{
"name": "Cab Service in Pimple Saudagar",
"description": "Book Cab Service in Pimple Saudagar for convenient local transportation and outstation travel with professional driver assistance. Sedan, SUV, Innova, and premium vehicle options can be selected for families, business travelers, airport transfers, and tourists."
},
{
"name": "Cab Service in Sangvi Pune",
"description": "Choose Cab Service in Sangvi Pune for reliable private transportation across local and outstation routes. The service provides comfortable vehicles for airport transfers, business travel, family journeys, sightseeing, and scheduled intercity trips."
},
{
"name": "Cab Service in Dighi Pune",
"description": "Book Cab Service in Dighi Pune for comfortable transportation with convenient pickup and drop arrangements. The service is suitable for local travel, airport transfers, corporate requirements, family trips, and outstation journeys from Dighi."
},
{
"name": "Cab Service in Moshi Pune",
"description": "Choose Cab Service in Moshi Pune for convenient local and outstation transportation with professional chauffeurs and well-maintained AC vehicles. Suitable cars can be arranged for families, corporate passengers, airport travelers, and long-distance journeys."
},
{
"name": "Cheapest Cab Service in Moshi Pune",
"description": "Book the Cheapest Cab Service in Moshi Pune for economical private transportation while maintaining practical travel comfort. Sedan and other suitable vehicle options can be arranged for local trips, airport transfers, family journeys, and outstation travel."
},
{
"name": "Cab Service in Chikhali Pune",
"description": "Choose Cab Service in Chikhali Pune for reliable chauffeur-driven transportation for local and outstation requirements. Comfortable AC vehicles are suitable for families, professionals, airport passengers, business travel, and long-distance road journeys."
},
{
"name": "Cab Service in Charholi",
"description": "Book Cab Service in Charholi for comfortable private transportation with convenient pickup arrangements. The service is suitable for local travel, airport transfers, family trips, corporate journeys, sightseeing, and outstation transportation."
},
{
"name": "Cab Service in Punawale",
"description": "Choose Cab Service in Punawale for convenient transportation across Pune and outstation destinations. Sedan, SUV, Innova, and premium vehicles can be arranged according to passenger count, luggage, travel schedule, and journey requirements."
},
{
"name": "Cab Service in Tathawade Pune",
"description": "Book Cab Service in Tathawade Pune for comfortable local and outstation travel with experienced chauffeurs. The service is suitable for students, families, corporate passengers, airport travelers, and customers planning intercity journeys."
},
{
"name": "Cab Service in Rahatani",
"description": "Choose Cab Service in Rahatani for reliable private transportation with flexible pickup and drop facilities. Comfortable AC vehicles can be arranged for local trips, airport transfers, business travel, family journeys, and outstation travel."
},
{
"name": "Cab Service in Dapodi",
"description": "Book Cab Service in Dapodi for convenient local and long-distance transportation with professional chauffeur assistance. The service is suitable for individuals, families, corporate passengers, airport travelers, and tourists requiring private cab transportation."
},
{
"name": "Cab Service in Ravet Pune",
"description": "Choose Cab Service in Ravet Pune for comfortable transportation across local and outstation routes. Sedan, SUV, Innova, and premium cars can be arranged for airport transfers, family travel, corporate journeys, sightseeing, and intercity trips."
},
{
"name": "Taxi Service in Pimpri Chinchwad",
"description": "Book Taxi Service in Pimpri Chinchwad for convenient private transportation with professional drivers and comfortable AC vehicles. The service is suitable for local journeys, airport transfers, corporate travel, family trips, and outstation transportation."
},
{
"name": "Best Cab Service in PCMC",
"description": "Choose the Best Cab Service in PCMC for comfortable and reliable private transportation supported by professional chauffeurs and well-maintained vehicles. The service is suitable for local travel, airport transfers, corporate journeys, family trips, and outstation routes."
},
{
"name": "Pimpri Chinchwad Cab Booking",
"description": "Make Pimpri Chinchwad Cab Booking for scheduled transportation with convenient pickup arrangements and suitable vehicle selection. Customers can arrange sedan, SUV, Innova, and premium cars for local, airport, corporate, family, and outstation travel."
},
{
"name": "Outstation Cab Service in Pimpri Chinchwad",
"description": "Choose Outstation Cab Service in Pimpri Chinchwad for comfortable long-distance transportation to cities and tourist destinations outside Pune. One-way and round-trip options can be arranged with suitable vehicles for families, groups, and business travelers."
},
{
"name": "Pimpri Chinchwad Taxi Near Me",
"description": "Find Pimpri Chinchwad Taxi Near Me for convenient private transportation with flexible pickup options across PCMC. Comfortable AC cabs can be arranged for local travel, airport transfers, business trips, family journeys, and outstation requirements."
},
{
"name": "Airport Cab Service in Pimpri Chinchwad",
"description": "Book Airport Cab Service in Pimpri Chinchwad for convenient airport pickup and drop transportation to and from Pune Airport. Sedan, SUV, Innova, and premium vehicles can be arranged according to passenger count, luggage, and travel requirements."
},
{
"name": "Affordable Cab in Pimpri Chinchwad",
"description": "Choose Affordable Cab in Pimpri Chinchwad for practical private transportation suitable for local and outstation travel. Customers can select economical sedan and other vehicle options according to their budget, passenger requirements, luggage, and journey type."
},
{
"name": "PCMC Cab Service 24/7",
"description": "Book PCMC Cab Service 24/7 for transportation support at different times of the day across Pimpri-Chinchwad. The service is suitable for airport transfers, early morning travel, late-night journeys, corporate requirements, family trips, and outstation transportation."
},
{
"name": "Pimpri Chinchwad Local & Outstation Cab",
"description": "Choose Pimpri Chinchwad Local & Outstation Cab for flexible transportation within PCMC as well as journeys to destinations outside Pune. Sedan, SUV, Innova, and larger vehicle options can be arranged for personal, family, corporate, and tourist travel."
}
],
"tableData": [
["Cab Service in Pimpri Chinchwad", "Cab Services in PCMC"],
["Cab Services in Wakad", "Cab Service in Aundh"],
["Cab Service in Baner", "Cab Service in Bhosari"],
["Outstation Cab Booking Pimpri Chinchwad", "Cab Service in Hinjewadi Pune"],
["Cab Service in Hinjewadi Phase 1", "Cab Service in Hinjewadi Phase 2"],
["Cab Service in Hinjewadi Phase 3", "Cab Service in Nigdi Pradhikaran"],
["Cab Service in Pune for Outstation", "Cab Service in Pimple Saudagar"],
["Cab Service in Sangvi Pune", "Cab Service in Dighi Pune"],
["Cab Service in Moshi Pune", "Cheapest Cab Service in Moshi Pune"],
["Cab Service in Chikhali Pune", "Cab Service in Charholi"],
["Cab Service in Punawale", "Cab Service in Tathawade Pune"],
["Cab Service in Rahatani", "Cab Service in Dapodi"],
["Cab Service in Ravet Pune", "Taxi Service in Pimpri Chinchwad"],
["Best Cab Service in PCMC", "Pimpri Chinchwad Cab Booking"],
["Outstation Cab Service in Pimpri Chinchwad", "Pimpri Chinchwad Taxi Near Me"],
["Airport Cab Service in Pimpri Chinchwad", "Affordable Cab in Pimpri Chinchwad"],
["PCMC Cab Service 24/7", "Pimpri Chinchwad Local & Outstation Cab"]
]
,



whychoose: [
  {
    WhyChooseheading: "Cab Service in Pimpri Chinchwad for Daily & Outstation Travel",
    WhyChoosedescription: "A private cab is a convenient transportation option across Pimpri Chinchwad for local trips, corporate travel, airport transfers, railway station drops, family outings, and journeys to nearby or outstation destinations."
  },
  {
    WhyChooseheading: "Pickup from Your Preferred PCMC Location",
    WhyChoosedescription: "Passengers can arrange pickup from their home, hotel, office, residential society, industrial area, railway station vicinity, or another accessible location across Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Comfortable Cars for Families & Groups",
    WhyChoosedescription: "Families, couples, professionals, and groups can select a suitable vehicle according to passenger numbers, luggage requirements, trip duration, and preferred comfort level."
  },
  {
    WhyChooseheading: "Convenient Airport & Railway Transfers",
    WhyChoosedescription: "Private cabs can be arranged for airport and railway station transportation, providing direct travel between Pimpri Chinchwad and your preferred transport terminal or destination."
  },
  {
    WhyChooseheading: "Useful for Corporate & Industrial Travel",
    WhyChoosedescription: "Businesses can arrange cabs for office visits, client meetings, industrial areas, factory locations, conferences, employee travel, and other professional transportation requirements across the PCMC region."
  },
  {
    WhyChooseheading: "Suitable for Local City Travel",
    WhyChoosedescription: "A private cab can be used for shopping, hotel transfers, family outings, residential travel, business appointments, restaurants, and other planned destinations throughout Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "One-Way & Outstation Cab Options",
    WhyChoosedescription: "Travellers can choose one-way or round-trip transportation from Pimpri Chinchwad to destinations such as Pune, Mumbai, Lonavala, Mahabaleshwar, Nashik, Satara, and other preferred cities."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Pimpri Chinchwad pickup location, destination, travel date, passenger count, luggage details, preferred vehicle, and local or outstation travel requirement with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Cab Service in Pimpri Chinchwad?",
    answer: "Yes, Garud Cab Service provides private cab services in Pimpri Chinchwad for local travel, airport transfers, railway station transportation, corporate trips, family outings, and outstation journeys."
  },
  {
    question: "Can I book a cab from anywhere in Pimpri Chinchwad?",
    answer: "Yes, pickup can be arranged from a preferred accessible location across Pimpri Chinchwad, including homes, hotels, offices, residential societies, industrial areas, and railway station surroundings."
  },
  {
    question: "Can I book a Pimpri Chinchwad cab for airport transfers?",
    answer: "Yes, private cabs can be arranged for airport pickup and drop requirements according to your preferred travel date and schedule."
  },
  {
    question: "Can I use the cab for local travel in Pimpri Chinchwad?",
    answer: "Yes, private cabs can be used for transportation between residential areas, offices, industrial locations, shopping destinations, hotels, railway stations, and other accessible places."
  },
  {
    question: "Does the service provide outstation cabs from Pimpri Chinchwad?",
    answer: "Yes, outstation cab arrangements can be planned from Pimpri Chinchwad for one-way and round-trip travel to destinations such as Pune, Mumbai, Lonavala, Mahabaleshwar, Nashik, Satara, and other cities."
  },
  {
    question: "Can companies book cabs in Pimpri Chinchwad?",
    answer: "Yes, companies can arrange private cabs for meetings, client visits, employee transportation, factory visits, industrial travel, conferences, and other business requirements."
  },
  {
    question: "Is the cab service suitable for families?",
    answer: "Yes, families and groups can select a suitable vehicle according to passenger numbers, luggage requirements, and comfort preferences."
  },
  {
    question: "Can I carry luggage in the Pimpri Chinchwad cab?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger luggage requirements should be communicated during booking."
  },
  {
    question: "Can I book a one-way cab from Pimpri Chinchwad?",
    answer: "Yes, one-way cab service can be arranged for passengers travelling to their preferred destination without requiring the same vehicle for the return journey."
  },
  {
    question: "How can I book a Cab Service in Pimpri Chinchwad?",
    answer: "Share your Pimpri Chinchwad pickup location, destination, travel date, passenger details, luggage requirements, preferred vehicle, and local or outstation travel requirement with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Jadhav",
    feedback: "I arranged a private cab in Pimpri Chinchwad for several office visits and client meetings. The direct pickup and travel between locations made my schedule much easier to manage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Pawar",
    feedback: "Our family booked a cab from Pimpri Chinchwad for an outstation trip. The private vehicle was convenient for travelling together and carrying our luggage comfortably.",
    rating: 5
  }
];








  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Pimpri Chinchwad",
  "image": "https://garudcabs.com/assets/images/cab-service-in-pimpri-chinchwad.webp",
  "description": "Book Cab Service in Pimpri Chinchwad with Garud Cab for safe, comfortable, and reliable local, airport, and outstation transportation. Get cab services across PCMC areas including Wakad, Aundh, Bhosari, Hinjewadi, and nearby locations. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles for daily travel, business trips, airport transfers, family journeys, local sightseeing, and outstation routes with convenient booking options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/cab-service-in-pimpri-chinchwad"
  }
};






  return (
    <div>

<Helmet>
  <title>Cab Service in Pimpri Chinchwad | PCMC Taxi & Cab Booking | +91 9970007784</title>

  <meta
    name="description"
    content="Book Cab Service in Pimpri Chinchwad with Garud Cab for reliable local, airport, and outstation travel. Get cab services in Wakad, Aundh, Bhosari, Hinjewadi, and other PCMC areas with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Cab Service in Pimpri Chinchwad, Cab Services in PCMC, Cab Services in Wakad, Cab Service in Aundh, Cab Service Baner, Cab Service in Bhosari, Outstation Cab Booking Pimpri Chinchwad, Cab Service in Hinjewadi Pune, Cab Booking in Pimpri Chinchwad, Taxi Service in PCMC, Taxi Service in Wakad, Taxi Service in Hinjewadi, PCMC Outstation Cab, Pimpri Chinchwad Airport Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/103.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinpimprichichwad;